import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LegalLinkItems } from "../legal/legalLinks";
import "./BlogStyles.css";

// Блог открывают из приложения, и в адрес утекают рабочие параметры вида
// ?project=...&tool=..., которые блогу не нужны и портят ссылку при шаринге
const BLOG_PARAMS = ["q", "section", "page", "category"];

function BlogShell({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const extra = [...params.keys()].filter((key) => !BLOG_PARAMS.includes(key));
    if (!extra.length) return;

    extra.forEach((key) => params.delete(key));
    const search = params.toString();
    navigate(`${location.pathname}${search ? `?${search}` : ""}`, { replace: true });
  }, [location.pathname, location.search, navigate]);

  return (
    <div className="blog-shell">
      <div className="blog-shell__backdrop" />
      <header className="blog-shell__header">
        <Link className="blog-shell__brand" to="/blog">
          <span className="blog-shell__eyebrow">Журнал Энилекс.Контроль</span>
          <span className="blog-shell__title">
            Блог о работе seller-команд на маркетплейсах
          </span>
        </Link>
        <nav className="blog-shell__nav" aria-label="Навигация блога">
          <Link className="blog-shell__nav-link" to="/blog">
            На главную блога
          </Link>
          <Link className="blog-shell__nav-link" to="/blog?section=Новости">
            Новости
          </Link>
          <Link className="blog-shell__nav-link" to="/blog?section=Статьи">
            Статьи
          </Link>
          <Link className="blog-shell__nav-link" to="/blog?section=Инструкции">
            Инструкции
          </Link>
          <Link className="blog-shell__nav-link blog-shell__nav-link--accent" to="/">
            В Энилекс.Контроль
          </Link>
        </nav>
      </header>
      <main className="blog-shell__main">{children}</main>
      <footer className="blog-shell__footer">
        <div className="blog-panel blog-footer__panel">
          <div className="blog-footer__meta">
            <span>
              Блог Энилекс.Контроль: практические материалы для Ozon,
              Wildberries и e-commerce команд.
            </span>
            <span className="blog-footer__legal">
              <LegalLinkItems short />
            </span>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default BlogShell;
